var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceToolkit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 805,
    height: 241,
    viewBox: "0 0 805 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.747 2.74695H258.625L202.857 99.0682H180.665L124.932 2.74695H144.919L191.761 84.5387L238.747 2.74695Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.023 50.8171C262.023 19.8425 282.01 0 324.081 0C366.151 0 385.994 19.9871 385.994 50.8171C385.994 81.6472 366.006 101.779 324.081 101.779C282.155 101.779 262.023 81.7917 262.023 50.8171ZM367.235 50.8171C367.235 26.023 351.332 15.6138 324.081 15.6138C296.829 15.6138 280.926 25.8784 280.926 50.8171C280.926 75.7559 296.937 86.165 324.081 86.165C351.224 86.165 367.235 75.6113 367.235 50.8171Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M421.992 2.74695V99.0682H404.463V2.74695H421.992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M502.121 0C538.698 0 557.456 16.5897 560.348 37.5526H541.445C538.843 23.8544 525.542 15.6499 502.121 15.6499C475.412 15.6499 459.256 25.9146 459.256 50.8533C459.256 75.792 475.556 86.2012 502.121 86.2012C525.397 86.2012 538.843 77.7076 541.445 64.0093H560.492C557.492 85.1169 538.698 101.815 502.121 101.815C460.485 101.815 440.353 81.9363 440.353 50.8533C440.353 19.7702 460.485 0 502.121 0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M680.343 18.0716H596.491V43.2633H677.596V58.4795H596.491V83.8158H680.343V99.032H578.961V2.74695H680.343V18.1077V18.0716Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.101 157.258H67.9708V237.929H50.586V157.258H0.274902V141.644H118.101V157.258Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.559 189.75C126.559 158.776 146.546 138.933 188.616 138.933C230.687 138.933 250.529 158.92 250.529 189.75C250.529 220.58 230.542 240.712 188.616 240.712C146.69 240.712 126.559 220.725 126.559 189.75ZM231.771 189.75C231.771 164.956 215.868 154.547 188.616 154.547C161.365 154.547 145.462 164.812 145.462 189.75C145.462 214.689 161.473 225.098 188.616 225.098C215.76 225.098 231.771 214.545 231.771 189.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M267.625 189.75C267.625 158.776 287.612 138.933 329.683 138.933C371.753 138.933 391.596 158.92 391.596 189.75C391.596 220.58 371.609 240.712 329.683 240.712C287.757 240.712 267.625 220.725 267.625 189.75ZM372.837 189.75C372.837 164.956 356.934 154.547 329.683 154.547C302.431 154.547 286.528 164.812 286.528 189.75C286.528 214.689 302.575 225.098 329.683 225.098C356.79 225.098 372.837 214.545 372.837 189.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M427.63 222.351H501.615V237.965H410.101V141.644H427.63V222.351Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M637.73 141.644L582.395 184.943L637.73 237.965H612.936L568.697 195.786L538.698 219.207V237.965H521.169V141.644H538.698V197.413L609.936 141.644H637.73Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M669.897 141.644V237.965H652.368V141.644H669.897Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M804.964 157.258H754.833V237.929H737.449V157.258H687.174V141.644H805V157.258H804.964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceToolkit);
export default __webpack_public_path__ + "static/media/VoiceToolkit.3efa2ec53fa44f53bfee63e340a4e36c.svg";
export { ForwardRef as ReactComponent };